import {Expose} from 'class-transformer'
import {Entity} from '@/app/common/base/entity'

export class DocumentSigning extends Entity<DocumentSigning> {
    @Expose({name: 'certificate_set_at'})
    certificateSetAt!: string

    @Expose({name: 'has_certificate'})
    hasCertificate!: boolean
}
